import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.8,
		d: "M6 3.5 10.5 8 6 12.5"
	})
});
export default SvgIconCaretRight;
